import { LunaClaimValues, UserIdentity, LunaClaimTypes } from "../../../models/user-identity.model";
import { Group } from "../../../admin/models/group.model";

export abstract class ViewBase {
    componentName: string;
    permissionType: LunaClaimTypes = LunaClaimTypes.Widget;
    requiredPermissions: string[];

    constructor(name: string, permissions: string[]) {
        this.componentName = name;
        this.requiredPermissions = permissions;
    }

    groupHasPermission(group: Group): boolean {
        return this.requiredPermissions.find(p => group.permissions.findIndex(gp => gp.type === this.permissionType &&  gp.value === p) != -1) != null;
    }

    userHasPermission(user: UserIdentity): boolean {
        return this.requiredPermissions.find(p => user.hasPermission(this.permissionType, p)) != null;
    }
}
